import { render, staticRenderFns } from "./VisitAttachmentsRemoveModal.vue?vue&type=template&id=0d638286&"
import script from "./VisitAttachmentsRemoveModal.vue?vue&type=script&lang=js&"
export * from "./VisitAttachmentsRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./VisitAttachmentsRemoveModal.vue?vue&type=style&index=0&id=0d638286&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports